import { CodingButtonsComponent } from './coding-buttons';
import { EditMatchButtonComponent } from './edit-match-button.component';
import { MatchCardComponent } from './match-card';
import { MatchInfoComponent } from './match-info';
import { MatchesListViewComponent } from './matches-list-view';
import { MatchesTableViewComponent } from './matches-table-view';
import { MatchPlaylistsComponent } from './match-playlists';

export const components: any[] = [
  CodingButtonsComponent,
  EditMatchButtonComponent,
  MatchCardComponent,
  MatchInfoComponent,
  MatchesListViewComponent,
  MatchesTableViewComponent,
  MatchPlaylistsComponent
];

export * from './coding-buttons';
export * from './edit-match-button.component';
export * from './match-card';
export * from './match-info';
export * from './matches-list-view';
export * from './matches-table-view';
export * from './match-playlists';
